<template>
  <div class="about-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">医院概况</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <aside class="sidebar">
        <div class="sidebar-section">
          <ul class="category-list">
            <li v-for="(article, index) in articles" :key="article.id" class="tree-item">
              <div class="tree-row">
                <span class="expand-icon empty"></span>
                <a href="#" @click.prevent="selectArticle(index, article)" 
                   :class="{ active: activeTab === index }">
                  {{ article.title }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </aside>

      <main class="main-layout">
        <article class="article-content" v-if="currentArticle">
          <h1 class="article-title">{{ currentArticle.title }}</h1>
          <div class="article-body" v-html="renderContent(currentArticle.content)">
          </div>
        </article>
        <div v-else class="loading-state">
          加载中...
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'About',
  data() {
    return {
      activeTab: 0,
      articles: [],
      currentArticle: null,
      flatCategories: [],
      aboutCategoryId: 1
    }
  },
  mounted() {
    this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get('/api/categories')
        if (response.data && response.data.flat) {
          this.flatCategories = response.data.flat
          const aboutCat = this.flatCategories.find(cat => cat.name === '医院概况')
          if (aboutCat) {
            this.aboutCategoryId = aboutCat.id
          }
          this.fetchArticles()
        }
      } catch (error) {
        console.error('获取分类失败:', error)
        this.fetchArticles()
      }
    },
    async fetchArticles() {
      try {
        const response = await axios.get('/api/posts', {
          params: {
            page: 1,
            size: 20,
            category_id: this.aboutCategoryId
          }
        })
        this.articles = response.data.data || []
        if (this.articles.length > 0) {
          this.selectArticle(0, this.articles[0])
        }
      } catch (error) {
        console.error('获取文章失败:', error)
      }
    },
    selectArticle(index, article) {
      this.activeTab = index
      this.currentArticle = article
    },
    renderContent(content) {
      if (!content) return ''
      let html = content
        .replace(/### (.*)/g, '<h3>$1</h3>')
        .replace(/## (.*)/g, '<h2>$1</h2>')
        .replace(/# (.*)/g, '<h1>$1</h1>')
        .replace(/\*\*(.*)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*)\*/g, '<em>$1</em>')
        .replace(/__(.*)__/g, '<u>$1</u>')
        .replace(/~~(.*)~~/g, '<del>$1</del>')
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        .replace(/```(\w+)?\n([\s\S]*?)```/g, '<pre><code>$2</code></pre>')
        .replace(/^> (.*)$/gm, '<blockquote>$1</blockquote>')
        .replace(/^- (.*)$/gm, '<li>$1</li>')
        .replace(/^\d+\. (.*)$/gm, '<li>$1</li>')
        .replace(/\n/g, '<br>')
      
      html = html.replace(/<li>/g, '<ul><li>').replace(/<\/li>(?!<li>)/g, '</li></ul>')
      
      return html
    }
  }
}
</script>

<style lang="less" scoped>
.about-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 300px;
  flex-shrink: 0;
  position: sticky;
  top: 175px;
  align-self: flex-start;
}

.sidebar-section {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li.tree-item {
    border-bottom: 1px dashed #eee;

    &:last-child {
      border-bottom: none;
    }

    .tree-row {
      display: flex;
      align-items: center;
      padding: 6px 0;

      .expand-icon {
        cursor: pointer;
        font-size: 8px;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        color: #4ecdc4;

        &.empty {
          cursor: default;
          color: transparent;
        }
      }

      a {
        flex: 1;
        font-size: 14px;
        color: #666;
        text-decoration: none;

        &:hover, &.active {
          color: #4ecdc4;
          font-weight: bold;
        }
      }
    }
  }
}

.main-layout {
  flex: 1;
}

.loading-state {
  text-align: center;
  padding: 80px 0;
  color: #999;
  font-size: 16px;
}

.article-content {
  flex: 1;
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .article-title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .article-meta {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;

    .meta-item {
      font-size: 14px;
      color: #666;
    }
  }

  .article-body {
    line-height: 1.8;
    color: #333;
    font-size: 16px;

    h1, h2, h3 {
      margin: 20px 0 15px;
      color: #333;
    }

    h1 { font-size: 24px; }
    h2 { font-size: 20px; }
    h3 { font-size: 18px; }

    p {
      margin-bottom: 15px;
    }

    strong { font-weight: bold; }
    em { font-style: italic; }
    u { text-decoration: underline; }
    del { text-decoration: line-through; }

    code {
      background: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      font-family: monospace;
    }

    pre {
      background: #333;
      color: white;
      padding: 15px;
      border-radius: 5px;
      overflow-x: auto;
      margin: 15px 0;

      code {
        background: none;
        padding: 0;
        color: inherit;
      }
    }

    blockquote {
      border-left: 4px solid #4ecdc4;
      padding-left: 15px;
      color: #666;
      margin: 15px 0;
      font-style: italic;
    }

    ul, ol {
      margin: 15px 0;
      padding-left: 30px;

      li {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
